/* eslint-disable no-lone-blocks */
import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import Card from "./Card";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "5rem 0",
  },
}));

export default function TableBox({ tableData }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        {tableData?.map((project) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item xs={12} md={6} lg={4} xl={4} key={project.id}>
            <Card
              id={project.id}
              image={project.product?.image_url}
              province={project.city?.name}
              city={project.city?.state?.name}
              title={project.title}
              status={project.status}
              description={project.description}
              priceId={project.product?.default_variant_id}
              price={project.variant?.price}
              orgName={project.organization?.name}
              orgLogo={project.organization?.logo}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
{
  /* <Grid item md={6} lg={4} xl={4}>
<Card />
</Grid>
<Grid item md={6} lg={4} xl={4}>
<Card />
</Grid>
<Grid item md={6} lg={4} xl={4}>
<Card />
</Grid> */
}
